import { render, staticRenderFns } from "./otcAccount.vue?vue&type=template&id=7a4f3185&scoped=true&"
import script from "./otcAccount.vue?vue&type=script&lang=js&"
export * from "./otcAccount.vue?vue&type=script&lang=js&"
import style0 from "./otcAccount.vue?vue&type=style&index=0&id=7a4f3185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f3185",
  null
  
)

export default component.exports